import { render, staticRenderFns } from "./SwitchComp.vue?vue&type=template&id=05478f4e&scoped=true"
import script from "./SwitchComp.vue?vue&type=script&lang=ts"
export * from "./SwitchComp.vue?vue&type=script&lang=ts"
import style0 from "./SwitchComp.vue?vue&type=style&index=0&id=05478f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05478f4e",
  null
  
)

export default component.exports